class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: 'is-hover',
      active: 'is-active',
      animate: 'show-from-bottom',
      clickOpen: 'is-click-open' 
    };

    this.selectors = {
      header: '.shopify-section-header',
      background: '.header-background',
      topMenuItem: '.header__menu-item--top',
      menus: 'dropdown-menu, mega-menu',
      wrapper: '.list-menu',
      childAnimate: '.list-menu-dropdown > .list-menu'
    };

    this.timeout = null;

    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onWrapperMouseLeave = this._onWrapperMouseLeave.bind(this);
    this._onDocumentClick = this._onDocumentClick.bind(this);

   
    this.addEventListener('mouseenter', this._onMouseEnter);

    this.addEventListener('click', this._onClick);
  }

  
 _onMouseEnter(e) {
  const anyClickOpen = document.querySelector('dropdown-menu.' + this.classes.clickOpen);
  if (anyClickOpen) return;

  if (this.classList.contains(this.classes.active)) return;

  this.handleMouseover();
}


  // _onClick(e) {
  //   const topLink = this.querySelector(this.selectors.topMenuItem);

  //   if (!topLink || !topLink.contains(e.target)) return;

  //   e.preventDefault();
  //   e.stopPropagation();

  //   if (this.classList.contains(this.classes.clickOpen)) {
  //     this._closeClickOpen();
  //   } else {
  //     this._openClickOpen();
  //   }
  // }

  _onClick(e) {
  const topLink = this.querySelector(this.selectors.topMenuItem);

  const hasChildren = this.querySelector('dropdown-menu');
  if (!hasChildren) {
    return; 
  }

  // Existing code continues here
  if (!topLink || !topLink.contains(e.target)) return;

  e.preventDefault();
  e.stopPropagation();

  if (this.classList.contains(this.classes.clickOpen)) {
    this._closeClickOpen();
  } else {
    this._openClickOpen();
  }
}


  _onWrapperMouseLeave() {
    if (this.classList.contains(this.classes.clickOpen)) return;

    this.handleMouseleave();
  }

  _onDocumentClick(e) {
    if (!e.target.closest('dropdown-menu')) {
      document.querySelectorAll('dropdown-menu.' + this.classes.clickOpen).forEach(menu => {
        menu._closeClickOpen();
      });
    }
  }

  
  _openClickOpen() {
    document.querySelectorAll('dropdown-menu.' + this.classes.clickOpen).forEach(menu => {
      if (menu !== this) menu._closeClickOpen();
    });

    this.reset();

    this.classList.add(this.classes.clickOpen, this.classes.active);

    this._ensureHeader().classList.add(this.classes.hover);

    this._bindWrapperLeave();

    document.addEventListener('click', this._onDocumentClick);
  }

  _closeClickOpen() {
    this.classList.remove(this.classes.clickOpen);
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    const header = this.header;
    if (header) {
      const stillHovering = header.querySelectorAll(this.selectors.menus + '.' + this.classes.hover).length > 0;
      if (!stillHovering) header.classList.remove(this.classes.hover);
    }

    const anyClickOpen = document.querySelector('dropdown-menu.' + this.classes.clickOpen);
    if (!anyClickOpen) {
      document.removeEventListener('click', this._onDocumentClick);
    }
  }


  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    this.bindEvent();        
    this.removeClasses();   
    this.addClasses();       
    this.resetBackground();
    this.animateMenu();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    if (this.wrapper && this.onHeaderMouseLeaveEvent) {
      this.wrapper.removeEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
    }
  }

  bindEvent() {
    
    this.onHeaderMouseLeaveEvent = this.onHeaderMouseLeaveEvent || this._onWrapperMouseLeave;

    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper);

    if (this.wrapper) {
      this.wrapper.addEventListener('mouseleave', this.onHeaderMouseLeaveEvent);
    }
  }

  addClasses() {
    const isTopLevel = this.querySelector(this.selectors.topMenuItem);

    let delay = 0;
    if (isTopLevel && !this.isHover()) {
      delay = 150;

      if (this.closest('.header--top-center') || this.closest('.header--top-left')) {
        delay = 200;
      }
    }

    this.timeout = setTimeout(() => {
      if (this.isHover() && !this.classList.contains(this.classes.clickOpen)) {
        this.classList.add(this.classes.active);
      }
    }, delay);

    this._ensureHeader().classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this._ensureHeader().querySelectorAll(this.selectors.menus);

    menus.forEach((menu) => {
      let found = false;
      const childMenus = menu.querySelectorAll('dropdown-menu');
      childMenus.forEach((element) => {
        if (element === this) {
          found = true;
          return;
        }
      });

      if (!found && typeof menu.reset === 'function' && !menu.classList.contains(this.classes.clickOpen)) {
        menu.reset();
      }
    });
  }

  isHover() {
    return this._ensureHeader().classList.contains(this.classes.hover);
  }

  reset() {
    if (this.classList.contains(this.classes.clickOpen)) return;

    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelector(this.selectors.childAnimate);
    if (childAnimate) childAnimate.classList.remove(this.classes.animate);

    clearTimeout(this.timeout);
  }

  resetBackground() {
    const background = this._ensureHeader().querySelector(this.selectors.background);
    if (background) background.classList.remove(this.classes.active);
  }

  animateMenu() {
    const childAnimate = this.querySelector(this.selectors.childAnimate);
    if (childAnimate) {
      setTimeout(() => {
        childAnimate.classList.add(this.classes.animate);
      }, 150);
    }
  }

  close() {
    this._closeClickOpen();
    this.handleMouseleave();
  }

 
  _ensureHeader() {
    this.header = this.header || document.querySelector(this.selectors.header);
    return this.header;
  }
}

customElements.define('dropdown-menu', DropdownMenu);


class MegaMenu extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      hover: "is-hover",
      active: "is-active",
      animate: "show-from-bottom",
    };
    this.selectors = {
      header: ".shopify-section-header",
      background: ".header-background",
      dropdown: ".list-menu-dropdown",
      menus: "dropdown-menu, mega-menu",
      wrapper: ".list-menu",
      childAnimate: ".mega-menu__item, .mega-menu__promo",
    };
    this.timeout = [];

    //this.addEventListener('focusin', this.handleMouseover.bind(this));
    this.addEventListener("mouseenter", this.handleMouseover.bind(this));
  }

  handleMouseover() {
    if (this.classList.contains(this.classes.active)) return;

    this.bindEvent();
    this.removeClasses();
    this.addClasses();
    this.showSublist();
  }

  handleMouseleave() {
    if (!this.header) return;

    this.reset();
    this.resetBackground();

    this.header.classList.remove(this.classes.hover);
    this.wrapper.removeEventListener(
      "mouseleave",
      this.onHeaderMouseLeaveEvent
    );
  }

  handleTouchMoveOutside(ev) {
    if (!this.header) return;

    let target_section = ev.targetTouches[0].target.closest(
      this.selectors.header
    );
    if (
      !target_section ||
      this.header.classList.contains("shopify-section-header-hidden")
    ) {
      this.reset();
      this.resetBackground();

      this.header.classList.remove(this.classes.hover);
      document.removeEventListener(
        "touchmove",
        this.onHeaderTouchMoveOutsideEvent
      );
    }
  }

  bindEvent() {
    this.onHeaderMouseLeaveEvent =
      this.onHeaderMouseLeaveEvent || this.handleMouseleave.bind(this);
    this.onHeaderTouchMoveOutsideEvent =
      this.onHeaderTouchMoveOutsideEvent ||
      this.handleTouchMoveOutside.bind(this);

    this.header = this.header || document.querySelector(this.selectors.header);

    this.wrapper = this.closest(this.selectors.wrapper);
    this.wrapper.addEventListener("mouseleave", this.onHeaderMouseLeaveEvent);
    document.addEventListener("touchmove", this.onHeaderTouchMoveOutsideEvent);
  }

  showSublist() {
    const dropdown = this.querySelector(this.selectors.dropdown);
    const background = this.header.querySelector(this.selectors.background);
    background.style.setProperty(
      "--height",
      this.header.clientHeight + dropdown.clientHeight + "px"
    );
    background.classList.add(this.classes.active);
  }

  addClasses() {
    this.classList.add(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    const delay = childAnimate.length > 5 ? 75 : 150;
    childAnimate.forEach((element, index) => {
      const timeout = setTimeout(() => {
        element.classList.add(this.classes.animate);
      }, delay * index + 100);

      this.timeout.push(timeout);
    });

    this.header.classList.add(this.classes.hover);
  }

  removeClasses() {
    const menus = this.header.querySelectorAll(this.selectors.menus);
    menus.forEach((menu) => {
      menu.reset();
    });
  }

  reset() {
    this.classList.remove(this.classes.active);

    const childAnimate = this.querySelectorAll(this.selectors.childAnimate);
    childAnimate.forEach((element) => {
      element.classList.remove(this.classes.animate);
    });
    this.timeout.forEach((timeout) => {
      clearTimeout(timeout);
    });
  }

  resetBackground() {
    const background = this.header.querySelector(this.selectors.background);
    background.classList.remove(this.classes.active);
  }

  close() {
    this.handleMouseleave();
  }
}
customElements.define("mega-menu", MegaMenu);
